import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { WarningPopUp } from "hesus-ui-kit";
import Header from "./components/Header/Header";
import PersonInChargeList from "../../PersonInCharge/PersonInChargeList";
import SellingPricesList from "../../SellingPrice/SellingPricesList";
import DocumentList from "../../Document/DocumentList/DocumentList";
import { loadSingleEnquiry } from "../EnquiryList/EnquiryList.actionCreators";
import {
  SiteViewContainer,
  FlexRow,
  SectionContainer,
  MarginBottom,
} from "./EnquiryView.styled";
import "./EnquiryView.scss";
import Tabs from "./components/Tabs";
import GeneralInfo from "./components/GeneralInfo";
import RelatedContactList from "../../RelatedContact/RelatedContactList/RelatedContactList";
import SolutionsList from "../../Solution/SolutionsList/SolutionsList";
/**
 * site GeneralInfo,
 * Path - /site/view/{id}
 * @see See [CenterProduct Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944335881/Site+view+page+-+General+layout)
 * @component
 */
const EnquiryView = (props) => {
  const { t, enquiryId, isRefeshData, setIsRefeshData } = props;

  const params = useParams();
  const [enquiryData, setEnquiryData] = useState([]);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [pageReload, setPageReload] = useState(false); // flag to avoid trigger fetch data call repeatively

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE_CONTENT"
  );
  const [isConfirm, setActionConfirmStatus] = useState(false);

  const dispatch = useDispatch();

  const enquiryInfo = useSelector((state) => state.enquiryList.byId[enquiryId]);

  const selectedEnquiryData = useSelector(
    (state) => state.enquiryList.selectedEnquiry
  );

  const [activeTab, setActiveTab] = useState("enquiry");
  const [activePriceTab, setActivePriceTab] = useState("solution");

  const fetchEnquiryInfo = () => {
    dispatch(
      loadSingleEnquiry({
        enquiryId,
      })
    );
  };

  useEffect(() => {
    if (!pageReload) {
      setPageReload(true);
      fetchEnquiryInfo();
    }
  }, []);

  useEffect(() => {
    if (isRefeshData) {
      fetchEnquiryInfo();
    }
  }, [enquiryInfo, enquiryId, isRefeshData]);

  useEffect(() => {
    if (pageReload) {
      if (
        selectedEnquiryData !== null &&
        parseInt(enquiryId, 10) === parseInt(selectedEnquiryData.id, 10)
      ) {
        setEnquiryData(selectedEnquiryData);
      } else if (
        enquiryInfo !== undefined &&
        parseInt(enquiryId, 10) === parseInt(enquiryInfo.id, 10)
      ) {
        setEnquiryData(enquiryInfo);
      } else fetchEnquiryInfo();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enquiryInfo, selectedEnquiryData]);

  const handleSiteStatus = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("COMPANY_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_ENABLE_CONTENT");
    } else {
      setConfirmationBoxTitle("COMPANY_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_DELETE_CONTENT");
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isRefeshData) {
      setIsRefeshData(false);
    }
  }, [isRefeshData]);

  const updateRefeshStatus = () => {
    setIsRefeshData(true);
  };

  let maineWidth = "100%";
  let marginLeft = "0px";
  if (params.path === "kickoff") {
    maineWidth = "auto";
    marginLeft = "inherit";
  }

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  const togglePriceTab = (tab) => {
    setActivePriceTab(tab);
  };

  return (
    <SiteViewContainer
      maineWidth={maineWidth}
      marginLeft={marginLeft}
      className="site-view-enquiry"
    >
      {enquiryData?.id && (
        <>
          <FlexRow>
            <SectionContainer>
              <Header
                enquiryData={enquiryData}
                setEnquiryData={setEnquiryData}
                handleSiteStatus={handleSiteStatus}
                updateRefeshStatus={updateRefeshStatus}
              />
            </SectionContainer>
          </FlexRow>
          <Tabs toggleTab={toggleTab} activeTab={activeTab} type="general" />
          {activeTab === "enquiry" && <GeneralInfo data={enquiryData} />}
          {activeTab === "contact" && (
            <RelatedContactList
              dependancies={JSON.stringify(["roles", "linkedEntities"])}
              entityType="request"
              entityId={enquiryData.id}
              companyId={enquiryData.site.companyId}
              countryId={enquiryData.site.platformCountry.id}
              parents
              headerNotRequired
              columnList={[
                "ID",
                "CONTACT_COMPANY",
                "CONTACT_NAME",
                "CONTACT_FUNCTION",
                "CONTACT_TYPE",
                "CONTACT_COMMUNICATION",
                "ACTIONS",
              ]}
            />
          )}
          {activeTab === "document" && (
            <DocumentList
              entityId={parseInt(enquiryData.id, 10)}
              entityType="requestId"
            />
          )}
          <PersonInChargeList
            objectId={parseInt(enquiryData.id, 10)}
            objectType="request"
            columnName="requestId"
            countryId={enquiryData?.site?.platformCountry?.id}
          />
          <MarginBottom></MarginBottom>
          <Tabs
            toggleTab={togglePriceTab}
            activeTab={activePriceTab}
            type="price"
          />
          {activePriceTab === "solution" && (
            <SolutionsList
              updateRequestRefeshStatus={updateRefeshStatus}
              enquiryId={enquiryData.id}
              siteId={enquiryData.site.id}
              enquiryStep={enquiryData.step}
              enquiryService={enquiryData?.service}
              setEnquiryData={setEnquiryData}
              enquirySubCategoryName={enquiryData?.subCategory?.name}
              enquirySubCategoryId={enquiryData?.subCategory?.id}
              countryId={enquiryData?.site?.platformCountry?.id}
              columnList={[
                "ID",
                "CENTRE",
                "PRODUCT",
                "PRICE",
                "COMMENTS",
                "STAGE",
                "REQUEST_MATCHINGS_LIST_ALLOCATION",
                "ACTION",
              ]}
            />
          )}
          {activePriceTab === "sellingPrice" && (
            <SellingPricesList
              objectId={parseInt(enquiryData.id, 10)}
              objectType="request"
              page="enquiryView"
              enquiryData={enquiryData}
              countryId={enquiryData?.site?.platformCountry?.id}
              columnList={[
                "SELLING_PRICE_INFORMATION",
                "QUANTITY",
                "SELLING_PRICE_ITEM_PRICE",
                "SELLING_PRICE_ITEM_TOTAL",
                "SELLING_PRICE_ITEM_MARGIN",
                "ACTIONS",
              ]}
            />
          )}
        </>
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </SiteViewContainer>
  );
};
EnquiryView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(EnquiryView);
